/**
 * @description Pattern of keys whose values we'd like to redact
 * @type {RegExp}
 */
const pattern = /password|jwt.?token/i;

/**
 * A JOSN function to mask values for specific keys
 * @param {string} key Key to match
 * @param {string} value Value to mask
 * @returns {Function}
 */
export default (key, value) => pattern.test(key)
    ? '[REDACTED]'
    : value
;
